import RadioButton from "components/BaseWidgets/radioButton";
import Switch from "components/BaseWidgets/switch";
import { privacyRadioData, privateExceptData } from "../../helper";
import CardLayout from "components/Settings/components/CardLayout";
import { usePremium } from "context/PremiumContext";
import GoPremiumModal from "components/CustomWidgets/goPremiumModal";
import { useState, useEffect } from "react";
import privacyConfig from "./config";

function ProfilePrivacy({ updatePrivacyData, privacyData }) {
  const { isPremium } = usePremium();
  const [showPremiumModal, setShowPremiumModal] = useState(false);

  useEffect(() => {
    if (
      !isPremium &&
      (privacyData?.profile_type === privacyConfig.private ||
        privacyData?.profile_type === privacyConfig.Private_except)
    ) {
      updatePrivacyData("profile_type", privacyConfig.public);
    }
  }, [isPremium, privacyData?.profile_type, updatePrivacyData]);

  return (
    <CardLayout title="Profile privacy">
      <div className="flex flex-col gap-4">
        <RadioButton
          options={privacyRadioData}
          value={privacyData?.profile_type}
          onChange={(e) => {
            const selectedValue = Number(e.target.value);

            if (!isPremium && (selectedValue === 2 || selectedValue === 3)) {
              setShowPremiumModal(true);
              return;
            }

            updatePrivacyData("profile_type", selectedValue);
          }}
          variant="primary"
          className="privacy-radio"
        />

        {privacyData?.profile_type === 3 && (
          <div className="flex flex-col gap-4">
            {privateExceptData.map(({ id, label }) => (
              <Switch
                key={id}
                id={id}
                label={label}
                isChecked={privacyData[id]}
                onChange={(checked) => updatePrivacyData(id, checked)}
              />
            ))}
          </div>
        )}
      </div>

      <GoPremiumModal
        open={showPremiumModal}
        wrapClassName={`go-premium-primary`}
        contentTitle="To unlock More features"
        buttonTitle="Upgrade plan"
        onCancel={() => {
          setShowPremiumModal(false);
        }}
        onOk={() => {
          setShowPremiumModal(false);
        }}
      />
    </CardLayout>
  );
}

export default ProfilePrivacy;
